import { type FC, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Header from '../../Header';
import { LockGroupsTable } from '../../Tables/LockGroups';
import { LocksTable } from '../../Tables/Locks';

export const LockManagement: FC = () => {
  const [activeTab, setActiveTab] = useState('locks');

  return (
    <Container fluid className="reservation-list-container">
      <Header title="Lock Management" />
      <Tabs
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key ?? 'locks')}
        className="mb-3"
      >
        <Tab eventKey="locks" title="Locks">
          <LocksTable />
        </Tab>
        <Tab eventKey="lock-groups" title="Lock Groups">
          <LockGroupsTable />
        </Tab>
      </Tabs>
    </Container>
  );
};
